import { Pipe, PipeTransform } from '@angular/core';
import { BccService} from './../../services/bcc/bcc.service';
import { map} from 'rxjs/internal/operators';
import { localConsole } from './../../utils/local-console';

@Pipe({
  name: 'editMedSwitch'
})
export class EditMedSwitchPipe implements PipeTransform {
  constructor(private _bccService: BccService) {}
  transform(value: any, ...args: any[]): any {
    const slotNum = '34701';
    return this._bccService.get(slotNum).pipe(map(bccdata => {
      let data: any = {};
      try {
        data = bccdata[slotNum] ? JSON.parse(atob(bccdata[slotNum])) : {};
      } catch (e) {
        localConsole.log(e);
      }
      if (data.order && !data.order.edit) {
        return false;
      }
      return true;
    }, error => {
      return true;
    }));
  }
}
